import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { Loading, useConfig, useTranslations } from "@jti/ui";
import { CartItem } from "../../../../components/CartItem";
import { CompactBundleItem } from "../../../../components/CartItem/CompactBundleItem";
import { CartItemList } from "../../../../components/CartItemList";
import { useCartMiniContext } from "../../../../contexts/CartMiniContext";
import styles from "./CartMiniItems.module.scss";
export const CartMiniItems = ({ pending, items, qtyPending, buyLimitation, onRemoveItemClick, onItemQuantityChange, onRemoveItems, }) => {
    const { __ } = useTranslations();
    const { displayBundleSelectedItems } = useConfig();
    const { isDarkTheme } = useCartMiniContext();
    if (pending) {
        return _jsx(Loading, {});
    }
    const itemsContainerClasses = classNames(styles.itemsContainer, {
        [styles.dark]: isDarkTheme,
    });
    const emptyContainerClasses = classNames(styles.emptyContainer, {
        [styles.dark]: isDarkTheme,
    });
    return (_jsx(CartItemList, { className: itemsContainerClasses, emptyClassName: emptyContainerClasses, items: items, testId: "mini-cart-list", emptyMessage: __("cart.cart_mini.no_items_in_cart"), variant: "compact", renderItem: (item) => item.type_id === "bundle" && displayBundleSelectedItems ? (_jsx(CompactBundleItem, { item: item, qtyPending: qtyPending, blockQuantityAdd: buyLimitation, onQuantityChange: onItemQuantityChange, onRemoveClick: onRemoveItemClick }, item.id)) : (_jsx(CartItem, { item: item, variant: "compact", qtyPending: qtyPending, blockQuantityAdd: buyLimitation, onRemoveClick: onRemoveItemClick, onQuantityChange: onItemQuantityChange }, item.id)), onRemoveItems: onRemoveItems }));
};
//# sourceMappingURL=CartMiniItems.js.map